import { EntityTypeCode, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { useViewer } from 'hooks/useViewer';
import { useEffect } from 'react';
import { RootStackType } from '../../Router';
import { initialState } from '../../rahtab-redux/slices/viewerSlice';
import { ScreenMainProps } from '../../types/screens';
import useCheckUser, { CheckUser } from './useCheckUser';
export const useHome = (): UseHome => {
  const { viewerSelectedEntity } = useViewerEntity();
  const { reset } = useNavigation<NavigationProp<RootStackType>>();
  const { data, loading, error } = useViewer();
  const { checkUser } = useCheckUser();

  useEffect(() => {
    if (viewerSelectedEntity?.typeCode !== EntityTypeCode.Provider) return;
    if (!loading && !error && data) {
      if (
        !data.name ||
        !data.storePhoneNumber ||
        !data.managerName ||
        !data.managerLastName ||
        !data.managerIdentificationNumber ||
        !data.managerMobileNumber ||
        !data.province ||
        !data.city ||
        !data.county ||
        !data.address ||
        !data.postalCode ||
        !data.latitude.toString() ||
        !data.longitude.toString()
      ) {
        reset({
          index: 0,
          routes: [{ name: 'CompleteInfo' }],
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data, error]);
  return {
    screenProps: {
      data,
      loading,
      transparentLoading: checkUser.checkUserLoading,
    },
    checkUser: checkUser.checkUser,
    userVerified: checkUser.userVerified,
  };
};

interface UseHome extends ScreenMainProps<typeof initialState> {
  checkUser: ({ userId, userPass, userType }: CheckUser) => Promise<void>;
  userVerified: boolean;
}
